import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "farey-algorithms" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Farey's Algorithm"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "NOTE:"),
    /*#__PURE__*/_createTextVNode("This page is incopmlete and still under construction")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "The method calculators use to convert complex decimal numbers to a more visually appealing fraction."),
  /*#__PURE__*/_createElementVNode("div", { class: "text-start" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Notable errors:"),
    /*#__PURE__*/_createElementVNode("ol", null, [
      /*#__PURE__*/_createElementVNode("li", null, "Javascript has at most 17 significant figures"),
      /*#__PURE__*/_createElementVNode("li", null, "Stack limit count (too many recursive calls because the decimal is too close to the limits, e.g. 1.0000000000001)")
    ])
  ])
], -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Examples", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_it_button = _resolveComponent("it-button")!
  const _component_it_number_input = _resolveComponent("it-number-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_it_button, {
        type: "black",
        outlined: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.farey(_ctx.inputVal)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Convert to Fraction")
        ]),
        _: 1
      }),
      _createVNode(_component_it_number_input, {
        modelValue: _ctx.inputVal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputVal) = $event)),
        "label-left": "Input Number",
        style: {"width":"125px"},
        "hide-controls": true,
        min: 0
      }, null, 8, ["modelValue"]),
      _hoisted_4,
      _createVNode(_component_it_button, {
        type: "black",
        outlined: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.farey(10.3)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("10.3")
        ]),
        _: 1
      }),
      _createVNode(_component_it_button, {
        type: "black",
        outlined: "",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.farey(2.765)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("2.765")
        ]),
        _: 1
      }),
      _createVNode(_component_it_button, {
        type: "black",
        outlined: "",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.farey(0.495)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("0.495")
        ]),
        _: 1
      }),
      _createVNode(_component_it_button, {
        type: "black",
        outlined: "",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.farey(123.456)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("123.456")
        ]),
        _: 1
      }),
      _createElementVNode("span", null, [
        _createElementVNode("sup", null, _toDisplayString(_ctx.outputVal[0]), 1),
        _createTextVNode(" ⁄ "),
        _createElementVNode("sub", null, _toDisplayString(_ctx.outputVal[1]), 1)
      ])
    ])
  ]))
}